import React from 'react';
import { useTranslation } from 'react-i18next';
import { FieldErrors } from 'react-hook-form';
import Icon from 'src/components/ui/Icon/Icon';

interface RegistrationFormErrorsProps {
  errors: FieldErrors;
}

const collectMessages = (errors: FieldErrors): string[] => {
  const messages: string[] = [];
  const walk = (node: unknown) => {
    if (!node || typeof node !== 'object') return;
    const maybeMessage = (node as { message?: unknown }).message;
    if (typeof maybeMessage === 'string' && maybeMessage.trim()) {
      messages.push(maybeMessage);
    }
    Object.entries(node as Record<string, unknown>).forEach(([key, value]) => {
      if (key === 'message' || key === 'type' || key === 'ref') return;
      walk(value);
    });
  };
  walk(errors);
  return Array.from(new Set(messages));
};

const RegistrationFormErrors: React.FC<RegistrationFormErrorsProps> = ({ errors }) => {
  const { t } = useTranslation();
  const messages = collectMessages(errors);
  if (messages.length === 0) return null;

  return (
    <div className="border border-subtle rounded-8 p-12 status-error-full flex gap-8">
      <Icon name="error" width={20} height={20} />
      <div>
        <p className="typo-text-14--bold mb-4">{t('registration.errors.summary_title')}</p>
        <ul className="list-disc pl-20">
          {messages.map(msg => (
            <li key={msg} className="typo-text-14">
              {msg}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default RegistrationFormErrors;
